import { IWorkflowDataState } from "src/app/shared/interfaces/workflow-data-state";

export abstract class BaseWorkflowState implements IWorkflowDataState {    
    abstract getPosition(): number;
    abstract setPosition(position: number): void;
}